import React, { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import YesNoRadioButton from "../../components/YesNoRadioButton";
import {
  getApiStatus,
  updateApiStatus,
} from "../../store/actions/switchAPIAction";

const STRING_FIELDS = ["documentProcessingType"];
const DEV_ONLY_API_KEYS = ["documentProcessingType", "easeMonthEndEnabled"];
const IDP_OPTIONS = ["NONE", "OCR", "IDP"];

const labelName = (name) => {
  switch (name) {
    case "easeApiResponse":
      return "Ease Api Response";
    case "omniDocResponse":
      return "Omni Doc Response";
    case "emailResponse":
      return "Email Response";
    case "smsResponse":
      return "Sms Response";
    case "billdeskResponse":
      return "Bill Desk Response";
    case "lcmsResponse":
      return "Lcms Response";
    case "disableOnlinePayment":
      return "Disable Online Payment";
    case "whatsappIntegrationResponse":
      return "WhatsApp Integration Service";
    case "hlAgentResponse":
      return "HL Agent Response";
    case "insta2Point":
      return "Insta 2.0 Response";
    case "tpaDocumentUpload":
      return "TPA Document Response";
    case "tpaMedicalScheduling":
      return "Medical Scheduling Response";
    case "billDeskResponseCallbackApiEnabled":
      return "Bill Desk Callback Response";
    case "cashPayment":
      return "Cash Payment";
    case "waiveOffMedicalsPanIndia":
      return "Waive Off Medicals (PAN India)";
    case "ocrServiceCall":
      return "OCR Service Call";
    case "newPivcRequired":
      return "New PIVC Required";
    case "formFillingEnabled":
      return "Self Form Filling";
    case "easeMonthEndEnabled":
      return "Ease Month End";
    case "documentProcessingType":
      return "Document Processing Type";
    default:
      return "";
  }
};

const SwitchApi = () => {
  const isDev = window.envType === "DEV";
  const dispatch = useDispatch();
  const { switchApiData } = useSelector((state) => ({
    switchApiData: state.switchApiReducer.switchApiData,
  }));
  const [apiList, setApiList] = useState({});

  useEffect(() => {
    dispatch(getApiStatus());
    return () => {
      setApiList({});
    };
  }, [dispatch]);

  useEffect(() => {
    const tempData = {};
    Object.keys(switchApiData).forEach((item) => {
      if (["id", "configName"].includes(item)) return;
      if (STRING_FIELDS.includes(item)) {
        tempData[item] = IDP_OPTIONS.includes(switchApiData[item])
          ? switchApiData[item]
          : "NONE";
      } else {
        tempData[item] = switchApiData[item] ? "yes" : "no";
      }
    });
    if (!tempData.documentProcessingType) tempData.documentProcessingType = "NONE";
    setApiList(tempData);
  }, [switchApiData]);

  const serviceItems = useMemo(
    () =>
      Object.keys(apiList).filter(
        (item) =>
          !["id", "configName"].includes(item) &&
          (isDev || !DEV_ONLY_API_KEYS.includes(item))
      ),
    [apiList, isDev]
  );

  const consvertAnswerstoBoolean = (data) => {
    const tempData = {};
    Object.keys(data).forEach((item) => {
      if (["id", "configName"].includes(item)) return;
      if (!isDev && DEV_ONLY_API_KEYS.includes(item)) return;
      if (STRING_FIELDS.includes(item)) {
        tempData[item] = data[item];
      } else {
        tempData[item] = data[item] === "yes";
      }
    });

    return tempData;
  };

  const handleChange = (name, value) => {
    const td = { ...apiList, [name]: value };
    setApiList(td);
    dispatch(updateApiStatus(consvertAnswerstoBoolean(td)));
  };

  return (
    <div className="proposal-dashboard switch-api">
      <div className="proposal-dashboard__header switch-api__header">
        <h2 className="proposal-dashboard__title">Proposal Submission Switch</h2>
        <p className="proposal-dashboard__subtitle">
          Manage ON/OFF status for proposal submission integrations
        </p>
      </div>

      <div className="proposal-dashboard__table-section switch-api__section">
        <div className="table-responsive">
          <table className="table table-striped switch-api__table">
            <thead>
              <tr>
                <th>Integration Service</th>
                <th className="switch-api__col-status">
                  <span className="switch-api__status-head">Status</span>
                </th>
              </tr>
            </thead>
            <tbody>
              {serviceItems.map((item) => (
                <tr key={item}>
                  <td className="switch-api__service">{labelName(item)}</td>
                  <td className="switch-api__col-status">
                    {STRING_FIELDS.includes(item) ? (
                      <div className="custom-select-container switch-api__select-wrap">
                        <select
                          className="switch-api__select"
                          value={apiList[item] || "NONE"}
                          onChange={(e) => handleChange(item, e.target.value)}
                        >
                          {IDP_OPTIONS.map((opt) => (
                            <option key={opt} value={opt}>
                              {opt}
                            </option>
                          ))}
                        </select>
                      </div>
                    ) : (

                      <YesNoRadioButton
                        cssClass="switch-api__toggle"
                        handleChange={handleChange}
                        rules={{
                          
                          editable: true,
                        }}
                        yesValue="yes"
                        noValue="no"
                        dataname={item}
                        checked={apiList[item]}
                      />
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default SwitchApi;
